import Box from "@mui/material/Box";
import { drawerWidth } from "./Dashboard";
import ModuleNotEnabledForOrganization from "./ModuleNotEnabledForOrganization";
import NoMembershipPage from "./NoMembershipPage";
import { useOrganizationContext } from "./OrganizationContext";
import { QUICK_ACCESS_APPBAR_HEIGHT, QUICK_ACCESS_APPBAR_HEIGHT_PLUS_MARGIN } from "../Helpers/Constants";

const DashboardContent = ({ data }) => {
  const { dashboard, item } = data;
  const { type } = dashboard;
  const { common } = item;
  const organizationContext = useOrganizationContext();
  const quickAccessItems = data?.quickAccessItems;
  const hasQuickAccess = quickAccessItems && quickAccessItems.length > 0;

  const isModuleEnabledForOrganization = !dashboard.isEnablableModule ||
    (dashboard.isEnablableModule && organizationContext?.isModuleEnabled(type));
  const shouldShowNoMembership = organizationContext?.isOrganizationContextAware && !organizationContext?.hasMemberships;

  return (
    <Box
      component="main"
      sx={{
        mt: hasQuickAccess ? QUICK_ACCESS_APPBAR_HEIGHT_PLUS_MARGIN : QUICK_ACCESS_APPBAR_HEIGHT,
        flexGrow: 1,
        width: { sm: `calc(100% - ${drawerWidth}px)` },
        position: 'relative',
        overflow: 'auto',
      }}
    >
      {/* <Toolbar sx={{ height: hasQuickAccess ? TOTAL_APPBAR_HEIGHT : APPBAR_HEIGHT }} /> */}
      <Box
        sx={{
          // mt: hasQuickAccess ? TOTAL_APPBAR_HEIGHT : APPBAR_HEIGHT,
          position: 'relative',
          zIndex: 1,
          p: { xs: 2, sm: 3, md: 4 },
          background: 'transparent',
        }}
      >
        {!isModuleEnabledForOrganization ? (
          <ModuleNotEnabledForOrganization
            moduleName={dashboard.name}
            modulePath={dashboard.path}
          />
        ) : (
          !common && shouldShowNoMembership ? <NoMembershipPage /> : item.element
        )}
      </Box>
    </Box>
  );
};

export default DashboardContent;
